import locale from 'date-fns/locale/en-GB';
export default locale;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-date-range/src/locale/en-GB.js
// module id = 473
// module chunks = 0